
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { URL_SERVICIOS } from '../config/config';
import { ErrorsService } from './errors.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ReservaDoctorService {

  constructor(
    public http: HttpClient,
    public router: Router,
    public _errors: ErrorsService,
  ) { }
  getInfoDoctor(use_id){
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    
    try {
      let data = this.http.post( URL_SERVICIOS + '/getInfoDoctor', {use_id: use_id}, httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }
  getVerificarPacienteAgenda(params){
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    
    try {
      let data = this.http.post( URL_SERVICIOS + '/getVerificarPacienteAgenda', JSON.stringify(params), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

  async postFinalizarAgendamientoAgendaDoctor(payload){
    let httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };
    
    try {
      let data = this.http.post( URL_SERVICIOS + '/postFinalizarAgendamientoAgendaDoctor', JSON.stringify(payload), httpOptions ).toPromise()
      return data
    }
    catch (error) {
      this._errors.requestError(error)
      throw error;
    }
  }

}
